import { round } from 'lodash';
import {
  MILLISECONDS_PER_SECOND,
  PERCENTAGE_MULTIPLIER,
  PROGRESS_DECIMAL_PLACES,
} from '../constants';
import type { ImageSetUploadSnapshot, UploadProgressDetails } from '../types';

/**
 * Derives the widget progress details for an image set from the uploader's byte and time counters.
 *
 * @param snapshot - The uploader's current counters.
 * @returns Progress percentage, speed in bytes per second, time left and time taken in seconds, and image counts.
 */
export const calculateUploadProgress = ({
  uploadedBytes,
  totalBytes,
  completedCount,
  totalCount,
  activeElapsedMs,
}: ImageSetUploadSnapshot): UploadProgressDetails => {
  const elapsedSeconds = activeElapsedMs / MILLISECONDS_PER_SECOND;
  const progress =
    totalBytes > 0
      ? round(
          (uploadedBytes / totalBytes) * PERCENTAGE_MULTIPLIER,
          PROGRESS_DECIMAL_PLACES,
        )
      : 0;
  const speed = elapsedSeconds > 0 ? uploadedBytes / elapsedSeconds : 0;
  const timeLeft = speed > 0 ? (totalBytes - uploadedBytes) / speed : 0;

  return {
    progress,
    speed,
    timeLeft,
    timeTaken: elapsedSeconds,
    counts: { uploaded: completedCount, total: totalCount },
  };
};
